import { useNavigate } from 'react-router-dom';
import { RegistrationTypeSelector } from '@/components/auth/registration-type-selector';
import { Button } from '@/components/ui/button';

export const Register = () => {
  const navigate = useNavigate();

  const handleSelectType = (type: 'individual' | 'business') => {
    if (type === 'business') {
      // Redirect to existing business registration flow from issue #78
      window.location.href = '/register/business';
    } else {
      navigate('/register/individual');
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 pt-6">
        <Button
          variant="ghost"
          className="px-0 h-auto bg-transparent hover:bg-transparent text-muted-foreground hover:text-foreground"
          onClick={() => navigate('/')}
        >
          ← Back to home
        </Button>
      </div>
      <RegistrationTypeSelector onSelectType={handleSelectType} />
    </div>
  );
};
